import Link from 'next/link'
import Button, { ButtonProps } from 'react-bootstrap/Button'

type Props = Omit<ButtonProps, 'as' | 'href'> & { href: string }

/**
 * react-bootstrap-Button, der als next/link rendert: <a role="button" class="btn ...">
 * mit Client-Navigation. Ersetzt das Next-12-Muster <Link passHref><Button as="a">,
 * das seit Next 13 nur noch mit dem deprecated `legacyBehavior` funktioniert.
 *
 * Der Cast ist nötig, weil @restart/ui `as` am Button nur als HTML-Tag typt;
 * zur Laufzeit akzeptiert react-bootstrap jede Komponente.
 */
const LinkButton = (props: Props) => <Button as={Link as unknown as 'a'} {...props} />

export default LinkButton
